import { createFailure, isSuccess } from "./OperationResult.js";
import { tryExecuteSimple } from "./tryExecuteSimple.js";
export async function tryExecute(func) {
    const result = await tryExecuteSimple(func);
    return isSuccess(result)
        ? result.value
        : createFailure({ type: "unexpected", message: result.fault });
}
